
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Tournament Photo Gallery </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fidechess-gallery section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Fide Chess Competition<span> Photo Gallery</span></h2>
        </div>
        <div class="row text-justify">

            <div class="col-md-12">




                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>FIDE CHESS COMPETITION 2021</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="Javascript:void(0);" class="cmn-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>


                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>FIDE CHESS COMPETITION 2018</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://photos.app.goo.gl/P1tGMifjiDIIzmcf1" target="_blank"
                                class="cmn-button"><span>
                                View More</span>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess7.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/fidechess-gallery/fide-chess8.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>


                    </ul>
                </div>

            </div>

        </div>


    </div>
</section>
